import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Fixes the "next page opens at the bottom" bug: every route change snaps the
// window back to the top instantly. Mount once inside BrowserRouter.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
